module.exports = __webpack_public_path__ + "img/printer-ordinary.2605b6a7.jpg";